export const CREDIT_KARMA_LEAD_URL =
  'https://apim.carvanatech.com/credit-karma/api/creditkarmalead/v1/no-encryption';
export const CREDIT_KARMA_SUBSCRIPTION_KEY = '2f0d7f5840f74ddca8c95e5e04e42e8c';
export const DEFAULT_CREDIT_KARMA_VEHICLE_ID = '1058063';

// Static applicant persona used to generate a Credit Karma lead.
const CREDIT_KARMA_PERSONA = {
  addressLine1: '2034 N SPLITSTONE',
  addressRegion: 'MI',
  addressRegionDisplay: 'Michigan',
  birthDate: '04/04/1944',
  city: 'PINCKNEY',
  income: '82000',
  lastName: 'TELLIER',
  phone: '5555551234',
  postalCode: '48169',
  ssn: '666-01-9999'
};

export type CreditKarmaLeadResponse = {
  C: {
    continueUrl: string;
  };
};

// Matches the common-user email format: <STATE>_<FIRST>_<LAST>_<timestamp>@automate.com
export function buildCreditKarmaEmail(firstName: string): string {
  const { addressRegion, lastName } = CREDIT_KARMA_PERSONA;

  return `${addressRegion}_${firstName.toUpperCase()}_${lastName}_${Date.now()}@automate.com`;
}

export function buildCreditKarmaPayload(
  email: string,
  firstName: string,
  vehicleId: string
) {
  const persona = CREDIT_KARMA_PERSONA;
  const currentDate = new Date().toISOString().split('T')[0];
  const timestamp = Math.floor(Date.now() / 1000).toString();

  return {
    agreements: {
      cardDetails: ' \n ',
      checkbox_ConsentToTradeIn: null,
      display_Terms:
        "By continuing, you're permitting us to share your information with Carvana and allowing Carvana to perform a soft inquiry on your credit report.",
      income_amount_annual:
        'Your annual individual income. You may include alimony, child support, or separate maintenance income if you wish to have it considered.',
      mileage_range: null,
      vin: null
    },
    applicant: {
      address_line1: persona.addressLine1,
      address_line2: '',
      address_region: persona.addressRegion,
      birth_date: persona.birthDate,
      car_selector: null,
      city: persona.city,
      ConsentToTradeIn: null,
      email,
      first_name: firstName,
      income_amount_annual: persona.income,
      last_name: persona.lastName,
      middle_initial: '',
      mileage_range: null,
      phone: persona.phone,
      postal_code: persona.postalCode,
      ssn: persona.ssn,
      vin: ''
    },
    application_id: 'fa6ab7c6-7d1b-42b6-bdfe-24710648fab2',
    display: {
      address_region: persona.addressRegionDisplay,
      ConsentToTradeIn: null,
      mileage_range: null
    },
    formatted: {
      address: `${persona.addressLine1} `,
      birth_date: '04041944',
      car_selector: null,
      phone: persona.phone,
      ssn: persona.ssn
    },
    lb: {
      down_payment: '0',
      lbmodelnumber: '30101',
      loan_amount: '23000',
      loan_apr: '8.5',
      loan_term: '60',
      monthly_payment: '471.88',
      utm_attributes: {
        click_source: 'OfferTile',
        correlation_id: '8ead7f8e-e284-4fe7-929f-c72cf26721b9',
        previous_visitcvna: 'N',
        product_code: 'FinSearch-v2-Landing-Vehicle',
        retarget_eligible: 'N'
      },
      vehicleInterest: {
        bodyStyle: 'Trailhawk',
        make: 'Jeep',
        model: 'Compass',
        vehicle_id: vehicleId
      }
    },
    metadata: {
      applied_date: currentDate,
      applied_timestamp: timestamp,
      contentId: 'carvana',
      ip_address: '71.94.235.18',
      revenue_id: '39444444444',
      surety: 'ITA',
      tmx_id: null,
      user_agent:
        'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:109.0) Gecko/20100101 Firefox/110.0'
    },
    product: {
      product_campaign: 'Offers',
      product_code: 'FinSearch-v2-Landing-Vehicle'
    }
  };
}
